import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { OnyxEvent } from '../../models/event';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { ReservationStore } from '../../service/reservation-store';
import { Observable } from 'rxjs/Observable';
import { AuthenticationStore } from '../../../permission/services/authentication.store';
import { ResponseUtil } from '../../../shared/utils/response-util';
import { ErrorHandlerService } from '../../../shared/utils/error-handler.service';

@Component({
  selector: 'pioneer-reservation-bulk',
  templateUrl: './reservation-bulk.component.html'
})
export class ReservationBulkComponent implements OnInit {

  @ViewChild(ModalDirective)
  public reservationBulkModal: ModalDirective;

  onyxEvent: OnyxEvent;

  fileExtensions: Array<string>;

  acceptedFileTypes: Array<string>;

  isUploadInProgress: boolean;

  public templateUrl: String;

  @ViewChild('file') fileInput: ElementRef;

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  @Input()
  public config = {
    backdrop: 'static',
    keyboard: false
  };

  @Output()
  public closed = new EventEmitter();

  constructor(private flashMessagesService: FlashMessagesService,
              private environment: EnvironmentConfiguration,
              private reservationStore: ReservationStore,
              private authenticationStore: AuthenticationStore,
              private errorHandlerService: ErrorHandlerService) { }

  ngOnInit() {

    this.isUploadInProgress = false;

    if (!this.onyxEvent) {
      throw new Error('The "event" attribute must be specified to use the ReservationBulk component');
    }

    this.fileExtensions = this.environment.reservations.acceptedFileExtensions;
    this.acceptedFileTypes = this.environment.reservations.acceptedFileTypes;
    this.templateUrl = this.environment.baseUrl
      + '/api/events/reservations/import/template?Authorization='
      + this.authenticationStore.getToken();
  }

  public open(): void {
    this.reservationBulkModal.show();
  }

  public close(value: boolean): void {
    this.closed.emit(value);
    this.reservationBulkModal.hide();
  }

  public cancel(): void {
    this.close(false);
  }

  public importReservationFile(inputEvent) {
    this.isUploadInProgress = true;

    if (!inputEvent || !inputEvent.srcElement || !inputEvent.srcElement.files || inputEvent.srcElement.files.size === 0) {
      this.handleUploadError('MESSAGES.ERROR.UPLOAD_BULK_RESERVATION');
      return;
    }

    const file = inputEvent.srcElement.files[ 0 ];
    this.clearFileInput();

    if (this.acceptedFileTypes.indexOf(file.type) < 0) {
      this.handleUploadError('MESSAGES.ERROR.UPLOAD_BULK_RESERVATION');
      return;
    }

    const eventId = this.onyxEvent.eventId;

    this.reservationStore.importReservationFile(eventId, file)
      .finally(() => {
        this.isUploadInProgress = false;
      })
      .catch((error => {
        this.handleUploadError(this.errorHandlerService.getErrorMessageFromBackendError(error),
          `Error uploading reservations file: ${error}`);
        return Observable.throw(error);
      }))
      .subscribe((response) => {
        this.flashMessagesService.success('MESSAGES.SUCCESS.UPLOAD_BULK_RESERVATION', false, false);
        this.close(true);
      });
  }

  private handleUploadError(errorMessage: string, logMessage: string = null) {
    this.isUploadInProgress = false;
    this.flashMessagesService.error(errorMessage, logMessage);
  }

  /**
   * This needs to be called whenever we do an upload so that someone could do a second upload with a different file
   * without having to reload the page.
   */
  private clearFileInput(): void {
    this.fileInput.nativeElement.value = null;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/reservations/reservation-bulk/reservation-bulk.component.ts